var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 203,
    viewBox: "0 0 201 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102 50.9935V101.987H51C51 73.8223 73.8317 50.9935 102 50.9935Z",
    fill: "#7CB0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102 0V50.9935C73.8317 50.9935 51 28.1647 51 0H102Z",
    fill: "#7CB0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H51C51 28.1647 28.1683 50.9935 0 50.9935V0Z",
    fill: "#7CB0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51 101.987H0V50.9935C28.1683 50.9935 51 73.8223 51 101.987Z",
    fill: "#7CB0FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100 152.5L100 102L201 102L201 203L100 203L100 152.5Z",
    fill: "#7CB0FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M174.517 129.129C186.542 141.155 186.542 160.651 174.517 172.677C162.492 184.702 142.995 184.702 130.97 172.677C118.945 160.651 118.945 141.155 130.97 129.129C142.995 117.104 162.492 117.104 174.517 129.129Z",
    fill: "#EBE9FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.226 50.6779L100.226 4.45959e-05L201 5.34058e-05L201 101.356L100.226 101.356L100.226 50.6779Z",
    fill: "#D3DDFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100 51L100 -1.20031e-06L150.208 51L201 102L100 102L100 51Z",
    fill: "#3AA0FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50 102H100V128C100 141.807 88.8071 153 75 153C61.1929 153 50 141.807 50 128V102Z",
    fill: "#EBE9FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100 152H94.3026C69.8349 152 50 171.835 50 196.303V203H100V152Z",
    fill: "#3AA0FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 102H25C38.8071 102 50 113.193 50 127C50 140.807 38.8071 152 25 152H0V102Z",
    fill: "#7CB0FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 152C27.6142 152 50 174.386 50 202V203H0V152Z",
    fill: "#EBE9FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.4110b0f2415b4b283f4130222c98b682.svg";
export { ForwardRef as ReactComponent };